import script from "./ProductInfo.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProductInfo.vue?vue&type=script&lang=ts&setup=true"

import "./ProductInfo.vue?vue&type=style&index=0&id=4cb20d44&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4cb20d44"]])

export default __exports__